import ReactDOM from 'react-dom/client'

import { Link } from 'react-router-dom';
import TypingAnimation from "/components/elements/animation/TypingAnimation";
import '/style.css';
import { Perf } from 'r3f-perf'
import { Canvas } from '@react-three/fiber'
import Experience from '/components/elements/3d/Experience.jsx'

function Home() {
  return (

    <>
    <div className="canvas-container">
      <Canvas
        shadows
        camera={{
          fov: 60,
          near: 0.3,
          far: 30,
          position: [0.0, 0, 10.2]

        }}
        style={{ position: 'absolute', top: '65px', left: 0, width: '100%', height: 'calc(100% - 65px)', aspectRatio: '16 / 9',}}
      >
        {/* <Perf/> */}
        <Experience />
      </Canvas>
</div>





      {/* <div className="text-wrapper">
        <div className="top-left">
          <TypingAnimation text="“Experience your data in a whole new way”" />
        </div>
        <div className="bottom-right">
          <TypingAnimation text="“Stunning visualizations and maps, revealing insights like never before”" />
        </div>
        <Link to="/services">
        <button className="home-page-button">Enter</button>
        </Link>
      </div> */}

    </>

  );
}

export default Home;